import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Users, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getFullName } from "../../services/common/util";

export function DeskOverview({ desks, timeRange = "today" }) {
    const navigate = useNavigate();

    const handleAgentClick = (agentId) => {
        navigate(`/agent/${agentId}`);
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle className="flex items-center">
                    <Users className="h-5 w-5 mr-2" />
                    {desks ? "My Desks Overview" : "Desks Overview"}
                </CardTitle>
            </CardHeader>
            <CardContent>
                {desks && desks.length && (
                    <Accordion type="single" collapsible className="w-full">
                        {desks.map((desk) => (
                            <AccordionItem key={desk._id} value={desk._id}>
                                <AccordionTrigger className="text-left">
                                    <div className="flex items-center justify-between w-full mr-4">
                                        <span className="font-medium">{desk.name}</span>
                                        <div className="flex items-center space-x-2">
                                            <Badge variant="outline">{desk.agents?.length} members</Badge>
                                            <Badge variant="secondary">{desk.leadCount} leads</Badge>
                                            <Badge variant="outline">
                                                {desk.callCount || 0} calls {timeRange}
                                            </Badge>
                                        </div>
                                    </div>
                                </AccordionTrigger>
                                <AccordionContent>
                                    <div className="pt-4 space-y-4">
                                        <div>
                                            <h4 className="font-medium text-gray-900 mb-2">Desk Manager</h4>
                                            <p className="text-sm">
                                                {desk.manager ? getFullName(desk.manager) : "Not assigned"}{" "}
                                                {/* <span className="text-xs text-gray-600">{desk.}</span> */}
                                            </p>
                                        </div>

                                        <div>
                                            <h4 className="font-medium text-gray-900 mb-2">Desk Members</h4>
                                            <div className="space-y-2">
                                                {(!desk.agents || !desk.agents.length) && <div>No members assigned</div>}
                                                {desk.agents && desk.agents.length > 0 &&
                                                    desk.agents.map((member) => (
                                                        <div
                                                            key={member._id}
                                                            className="flex items-center justify-between p-2 bg-gray-50 rounded"
                                                        >
                                                            <Button
                                                                variant="link"
                                                                className="p-0 h-auto text-sm font-medium text-blue-600 hover:text-blue-800"
                                                                onClick={() => handleAgentClick(member._id)}
                                                            >
                                                                {getFullName(member)}
                                                            </Button>
                                                            <div className="flex items-center text-sm text-gray-500">
                                                                <Phone className="h-4 w-4 mr-1" />
                                                                {member.callCount || 0} calls {timeRange}
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                )}
            </CardContent>
        </Card>
    );
}
